import {
  faArrowDown,
  faArrowUp,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { Box, Chip, Typography } from "@mui/material";
import GetIcon, { GetFontAwesomeIcon } from "@/components/font-awesome-icon";
import ActionPopover from "../page-header/actions-popover";
import { colorEnums } from "@/modules/crm/dashboard/helper";
import { WidgetDurationEnums } from "@/services/dropdown-enums";

const CardWidget = ({
  color = "purple",
  Icon,
  materialIcon = false,
  previousValue,
  currentValue,
  title,
  unit = "",
  filter,
  onFilterChange,
  loading = false,
  sx = {},
  isDashboardWidget = false,
  hideFilter = false,
  iconStyles = {},
}) => {
  const diff = currentValue - previousValue;
  // const average = (currentValue + previousValue) / 2;
  // const percentage = diff == 0 ? 0 : (diff / average) * 100;
  const isNegative = diff < 0 ? true : false;
  const percentage =
    !previousValue && !currentValue
      ? 0
      : !previousValue
        ? 100
        : ((currentValue - previousValue) / previousValue) * 100;

  const generateOpt = () => {
    return Object.keys(WidgetDurationEnums).map((key) => ({
      id: WidgetDurationEnums[key],
      title: key.split("_").join(" "),
    }));
  };

  return (
    <Box
      sx={{
        flex: "1",
        borderRadius: "5px",
        // background: colorEnums[color].bg,
        border: "1px solid var(--palette-stroke)",
        background: "var(--palette-grid_table)",
        padding: "0.8rem 1.5rem",
        ...sx,
      }}
    >
      <Box className="d-flex justify-content-space-between align-items-center">
        <Typography
          variant="h3"
          fontWeight={700}
          // color={colorEnums[color].text}
          // color={"var(--palette-secondary_button_text)"}
          sx={{ fontSize: "1.5rem" }}
          className="d-flex align-items-center"
        >
          {!isDashboardWidget ? (
            <Box
              sx={{
                padding: "4px 10px",
                background: colorEnums[color].bg,
                borderRadius: "5px",
              }}
            >
              {materialIcon ? (
                <Icon
                  style={{
                    fontSize: "1.3rem",
                    marginRight: "0px",
                    color: colorEnums[color].text,
                  }}
                />
              ) : (
                <GetFontAwesomeIcon
                  icon={Icon}
                  iconStyles={{
                    fontSize: "1.2rem",
                    marginRight: "0px",
                    color: colorEnums[color].text,
                    ...iconStyles,
                  }}
                />
              )}
            </Box>
          ) : null}
          &nbsp;
          {currentValue}
          {unit}
        </Typography>
        {!hideFilter && (
          <ActionPopover
            disablePadding={true}
            handleClick={onFilterChange}
            options={generateOpt()}
            clickNode={
              <Typography
                className="cursor-pointer"
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: 600,
                  color: "var(--palette-text)",
                  my: 0.5,
                }}
              >
                {generateOpt().find((v) => v.id == filter?.id)?.title ||
                  "select"}
                <GetFontAwesomeIcon
                  icon={faChevronDown}
                  iconStyles={{ marginLeft: "5px" }}
                />
              </Typography>
            }
          />
        )}
      </Box>
      <Box
        className="d-flex justify-content-space-between align-items-center"
        sx={{ mt: 1 }}
      >
        <Typography
          className="d-flex justify-content-space-between"
          fontWeight={600}
          sx={{ fontSize: "0.9rem" }}
          // color={colorEnums[color].text}
          color={"var(--palette-secondary_button_text)"}
        >
          {title}
          {/* {loading ? <CircularProgress size={"17px"} /> : null} */}
        </Typography>
        <Chip
          size="small"
          label={
            <GetIcon
              iconStyles={{ fontSize: "0.725rem", fontWeight: "600" }}
              icon={isNegative ? faArrowDown : faArrowUp}
              title={
                <Typography sx={{ fontWeight: "600" }}>
                  {Math.abs(Math.trunc(percentage * 10) / 10)}%
                  {/* {Math.abs(Number(percentage.toFixed(1)))}% */}
                </Typography>
              }
            />
          }
          sx={{
            backgroundColor: "var(--palette-background)",
            color: isNegative
              ? colorEnums["orange"].text
              : colorEnums["green"].text,
            "& .MuiChip-label": {
              "& .MuiFormControlLabel-label": {
                fontSize: "0.725rem",
                lineHeight: "1",
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default CardWidget;
